import axios from "axios";

function registerThirdPartyServices(Vue) {
  Vue.http = Vue.prototype.$http = axios;
  Vue.config.productionTip = false;

  const dependencies = [];

  dependencies.forEach((dependency) => {
    Vue.use(dependency);
  });
}

export default registerThirdPartyServices;
